import gameInfo from '../assets/json/gameInfo.json'
import Phaser from 'phaser';
import gameData from './gameData.js';
import FontKeys from './FontKeys';
import ABCyaLib from '@abcya/abcya_lib';
import ABCyaPhaser from '@abcya/abcya_phaser';

const fonts = [];
for (let k in FontKeys)
{
    fonts.push(FontKeys[k]);
}

// note: uncomment or change the following based on what you need to load
ABCyaPhaser.Preloader.PreloaderConfig.fonts = fonts;
/**
 * To load multiple image sprites, change this property to an array of Phaser.Types.Loader.FileTypes.MultiAtlasFileConfig objects.
 * Ex: ABCyaPhaser.Preloader.PreloaderConfig.imagesPath = [
 * { key: ABCyaPhaser.Images.DEFAULT_ATLAS, atlasURL: 'assets/images/' + ABCyaPhaser.Images.DEFAULT_ATLAS + '.json', path: 'assets/images' }, // default multiatlas
 * { key: "particles", atlasURL: 'assets/images/particles.json', path: 'assets/images' }
 * ]
 */

 ABCyaPhaser.Preloader.PreloaderConfig.imagesPath = [
     { key: ABCyaPhaser.Images.DEFAULT_ATLAS, atlasURL: 'assets/images/' + ABCyaPhaser.Images.DEFAULT_ATLAS + '.json', path: 'assets/images' }, // default multiatlas
    //  { key: "barnumIMGs", atlasURL: 'assets/images/barnumIMGs.json', path: 'assets/images' }
]
/**
 * To load multiple audio sprites, change this property to an array of Phaser.Types.Loader.FileTypes.AudioSpriteFileConfig objects.
 * Note: you should always include an ogg and mp3 file, the game will determine which to use based on compatibility. 
 * Ex: ABCyaPhaser.Preloader.PreloaderConfig.soundsPath = [
 * { key: ABCyaPhaser.Audio.DEFAULT_AUDIO_SPRITE, 
 *   jsonURL: 'assets/sounds/' + DEFAULT_AUDIO_SPRITE + '.json', 
 *   audioURL: [ 'assets/sounds/' + DEFAULT_AUDIO_SPRITE + '.ogg', 'assets/sounds/' + DEFAULT_AUDIO_SPRITE + '.mp3' ] }, // default sound sprite
 * { key: "extrasounds", jsonURL: 'assets/sounds/extrasounds.json', audioURL: [ 'assets/sounds/extrasounds.ogg', 'assets/sounds/extrasounds.mp3' ] }
 * ]
 */
ABCyaPhaser.Preloader.PreloaderConfig.soundsPath = 'assets/sounds';
/**
 * You can load spine objects here. This can be an object with key, jsonPath, and atlasPath properties, or an array of those objects.
 * Ex: ABCyaPhaser.Preloader.PreloaderConfig.spines = [
 * { key: "spine0", jsonPath: "assets/spines/spine0.json", atlasPath: "assets/spines/spine0.atlas" },
 * { key: "spine1", jsonPath: "assets/spines/spine1.json", atlasPath: "assets/spines/spine1.atlas" }
 * ]
 */
// ABCyaPhaser.Preloader.PreloaderConfig.spines = { key: "Barnum", jsonPath: "assets/spine/Barnum.json", atlasPath: "assets/spine/Barnum.atlas" };

ABCyaPhaser.Preloader.PreloaderConfig.startScene = gameData.startScene;

/**
 * Called when the preload function is done.
 * @param {Phaser.Scene} scene the preloader scene
 */
ABCyaPhaser.Preloader.PreloaderConfig.preloadCallback = scene =>
{
    // insert additional preloader functionality here; scene is the preloader scene
    scene.events.once(Phaser.Scenes.Events.CREATE, ()=>{
      /** @type {string[]} */
      const words = [...ABCyaPhaser.Localization.instance.getLocalizedData("word_bank")];
      words.filter(word => {
        if(word.indexOf('á') !== -1 || word.indexOf('é') !== -1 || word.indexOf('í') !== -1 || word.indexOf('ó') !== -1 || 
        word.indexOf('ú') !== -1 || word.indexOf('ü') !== -1 || word.indexOf('ñ') !== -1) {
            console.warn("Words cannot include accented characters, removing '" + word + "' from the data set.");
            return true;
        }
      }).forEach(wordToRemove => Phaser.Utils.Array.Remove(words, wordToRemove));
      if(words.length > 0){
        gameData.WORD_BANK.push(...words);
      }

      console.log("Word bank:");
      console.log(gameData.WORD_BANK);
    });
}

(async function handshake()
{
    try
    {
        await ABCyaLib.Environment.instance.doParentHandshake();
    } catch (error)
    {
        console.warn(error);
    }

    console.info("ABCya Game Info:", gameInfo);
    
    /**
     * Use the fourth argument of initializePhaserGame to override default Phaser config options
     * For example: to use the Spine plugin, the fourth argument should look like this:
     * { 
            configOverrides: {
                plugins: {d
                    scene: [
                        { key: 'SpinePlugin', plugin: window.SpinePlugin, mapping: 'spine' }
                    ]
                }
            }
        }
     */
    gameData.DESKTOP = ABCyaLib.DEVICE_INFO.desktop;
    // gameData.DESKTOP = false;

    // console.log(gameData.DESKTOP);
    const layout = gameData.DESKTOP ? {x:1024, y:768} : {x:768, y:1024};
    ABCyaPhaser.Misc.initializePhaserGame(layout.x, layout.y, gameData.scenes);

    // initialize any functionality in abcya_phaser that has a dependency on abcya_lib 
    ABCyaPhaser.Misc.initializeAbcyaLibDependencies(ABCyaLib);
})();
